import { CLEAR_ALL } from '../constants';

export const SET_PROJECT_CREATION_DRAFT = 'SET_PROJECT_CREATION_DRAFT';
export const CLEAR_PROJECT_CREATION_DRAFT = 'CLEAR_PROJECT_CREATION_DRAFT';

export interface ProjectCreationDraftState {
  messages: Array<{ role: string; content: string; timestamp: string }>;
  collectedData: Record<string, any>;
  savedAt: number | null;
}

const initialState: ProjectCreationDraftState = {
  messages: [],
  collectedData: {},
  savedAt: null,
};

interface SetDraftAction {
  type: typeof SET_PROJECT_CREATION_DRAFT;
  payload: { messages: ProjectCreationDraftState['messages']; collectedData: Record<string, any> };
}

interface ClearDraftAction {
  type: typeof CLEAR_PROJECT_CREATION_DRAFT;
}

type DraftAction = SetDraftAction | ClearDraftAction | { type: typeof CLEAR_ALL };

export default function projectCreationDraftReducer(
  state: ProjectCreationDraftState = initialState,
  action: DraftAction,
): ProjectCreationDraftState {
  switch (action.type) {
    case SET_PROJECT_CREATION_DRAFT:
      return {
        messages: action.payload.messages,
        collectedData: action.payload.collectedData,
        savedAt: Date.now(),
      };
    case CLEAR_PROJECT_CREATION_DRAFT:
    case CLEAR_ALL:
      return initialState;
    default:
      return state;
  }
}
